<app-loader class="app-loader"></app-loader>
<router-outlet></router-outlet>
